import React from "react";
import { GuidanceComponent } from "./guidance.component";

export const GuidancePage = () => {
  return <GuidanceComponent />;
};
